/** useComplianceBadge — module-shared poller for the sidebar compliance count.
 * A single interval per workspace, no matter how many components subscribe. */
import { useEffect, useState, useSyncExternalStore } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

let currentWs = null;
let currentInterval = null;
let subscribers = new Set();
let currentData = null;

function notify() {
  for (const cb of subscribers) cb();
}

async function fetchOnce(wsId) {
  try {
    const { data } = await api.get(`/workspaces/${wsId}/compliance-badge`);
    if (currentWs === wsId) { currentData = data; notify(); }
  } catch {
    // silent fail; keep previous value
  }
}

function ensurePolling(wsId) {
  if (currentWs === wsId) return;
  currentWs = wsId;
  currentData = null;
  if (currentInterval) { clearInterval(currentInterval); currentInterval = null; }
  if (!wsId) { notify(); return; }
  fetchOnce(wsId);
  currentInterval = setInterval(() => fetchOnce(wsId), 60000);
}

function subscribe(cb) {
  subscribers.add(cb);
  return () => {
    subscribers.delete(cb);
    if (subscribers.size === 0 && currentInterval) {
      clearInterval(currentInterval); currentInterval = null; currentWs = null;
    }
  };
}
function getSnapshot() { return currentData; }

export function useComplianceBadge() {
  const { activeWorkspaceId: wsId } = useAuth();
  useEffect(() => { ensurePolling(wsId); }, [wsId]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
